import { callBackendCommand, firebaseFunctionCommands } from '@/backend';
import type { ProjectScope } from '../../sync/project-scope';

/**
 * Mark a single notification as read.
 */
export async function markAsRead(userId: string, notificationId: string): Promise<void> {
  await callBackendCommand(firebaseFunctionCommands.markUserNotificationRead, {
    userId,
    notificationId,
  });
}

/**
 * Mark all unread notifications as read for a user.
 * Uses a batch write (max 500 per batch — well within expected cardinality).
 */
export async function markAllRead(userId: string, scope: ProjectScope): Promise<void> {
  await callBackendCommand(firebaseFunctionCommands.markAllUserNotificationsRead, {
    userId,
    orgId: scope.orgId,
    projectId: scope.projectId,
  });
}

/**
 * Mark a notification as resolved (e.g., roster-update accepted).
 */
export async function resolveNotification(userId: string, notificationId: string): Promise<void> {
  await callBackendCommand(firebaseFunctionCommands.resolveUserNotification, {
    userId,
    notificationId,
  });
}
